import { gql } from '@apollo/client';
import UPDATE_CLASSROOM_SETTING_FRAGMENT from '../../fragments/update-classroom-setting-fragment';

const UPDATE_HWT_CLASSROOM_LANGUAGE_SETTING = gql`
  mutation updateHwtClassroomSettingLanguage($data: [UpdateHwtClassroomSettingLocaleInput!]!) {
    updateHwtClassroomSettingLanguage(data: $data) {
      ...UpdateClassroomSettingFragment
    }
  }
  ${UPDATE_CLASSROOM_SETTING_FRAGMENT}
`;

export default UPDATE_HWT_CLASSROOM_LANGUAGE_SETTING;
